import type { Organization } from '@interfaces/organization';
import { createContext, useContext } from 'react';

export type HouseholdContextType = {
  id?: string;
  orgSettings: Organization & { id?: string };
  members: { id: string; initials?: string; name?: string }[];
  indexedMembers: Record<string, number>;
  totalMarketValueCents: number;
};

export const HouseholdContext = createContext<HouseholdContextType | undefined>(
  undefined,
);

export const useHouseholdContext = (): HouseholdContextType | undefined =>
  useContext(HouseholdContext);
